/**
 * Labstep
 *
 * @module components/FilterPost/Active/Label
 * @desc Filter Post Active Label
 */

import { ExperimentWorkflowFilterStatusActive } from 'labstep-web/components/ExperimentWorkflow/Filter/Status/Active';
import ExperimentWorkflowPostFilterSignedActive from 'labstep-web/components/ExperimentWorkflow/PostFilter/Signed/Active';
import { LocationService } from 'labstep-web/services/location.service';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { FilterPostActiveLabelRouterProps } from './types';

export const FilterPostActiveLabelRouter: React.FC<
  FilterPostActiveLabelRouterProps
> = ({ history, location }): React.ReactElement | null => {
  const params = LocationService.getQueryParameters(location);
  return (
    <>
      <ExperimentWorkflowPostFilterSignedActive
        clearParams={() => {
          LocationService.removeQueryParameter(
            history,
            location,
            'signature_request_user_id',
          );
        }}
        searchParams={params}
      />
      <ExperimentWorkflowFilterStatusActive
        clearParams={() => {
          LocationService.removeQueryParameter(
            history,
            location,
            'entity_state_name',
          );
        }}
        searchParams={params}
      />
    </>
  );
};

export default withRouter(FilterPostActiveLabelRouter);
